import * as React from 'react';
import * as Dialog from '@radix-ui/react-dialog';
import { Eye, X } from 'lucide-react';
import { cn } from '@/utils/utils';

export interface ImageProps
    extends React.ImgHTMLAttributes<HTMLImageElement> {
    wrapperClassName?: string,
    thumbClassName?: string,
    fullClassName?: string
}

const Image = React.forwardRef<HTMLDivElement, ImageProps>(
    ({ src, alt, wrapperClassName, thumbClassName, fullClassName, ...props }, ref) => {
        return (
            <Dialog.Root>
                {/* Thumbnail + Eye overlay */}
                <div
                    ref={ref}
                    className={cn(
                        'relative inline-block group overflow-hidden rounded',
                        wrapperClassName
                    )}
                >
                    <img
                        src={src}
                        alt={alt}
                        className={cn('h-32 w-32 object-cover', thumbClassName)}
                        {...props}
                    />
                    <Dialog.Trigger asChild>
                        <button
                            type='button'
                            className='absolute inset-0 flex items-center justify-center
                         bg-black/40 opacity-0 group-hover:opacity-100
                         transition-opacity duration-200'
                        >
                            <Eye className='w-6 h-6 text-white' />
                        </button>
                    </Dialog.Trigger>
                </div>

                {/* Overlay + Content */}
                <Dialog.Portal>
                    <Dialog.Overlay className='fixed inset-0 bg-black/70 z-40' />
                    <Dialog.Content className='fixed inset-0 flex items-center justify-center z-50 p-4'>
                        <img
                            src={src}
                            alt={alt}
                            className={cn(
                                'max-h-[90vh] max-w-[90vw] rounded shadow-lg',
                                fullClassName
                            )}
                        />

                        {/* Nút đóng */}
                        <Dialog.Close asChild>
                            <button
                                className='absolute top-4 right-4 p-2 rounded-full bg-black/60
                           hover:bg-black/80 transition-colors'
                            >
                                <X className='h-5 w-5 text-white' />
                            </button>
                        </Dialog.Close>
                    </Dialog.Content>
                </Dialog.Portal>
            </Dialog.Root>
        );
    }
);

Image.displayName = 'Image';

export { Image };
